import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Admin from './Pages/Admin';
import TimeAdmin from './Pages/Time';
import TournamentPage from './Pages/Tournament';
import TournamentAdminPage from './Pages/TournamentAdmin';
import CancelPage from './Pages/Cancel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cancel/:token" element={<CancelPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/time" element={<TimeAdmin />} />
        <Route path="/tournament" element={<TournamentPage />} />
        <Route path="/tournament-admin" element={<TournamentAdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;
